import React, { useRef } from 'react';

import CompositeLiveIndicator from './CompositeLiveIndicator';
import CompositePublishSettingsForm from './CompositePublishSettingsForm';
import Compositor from './Compositor';
import InputLayoutSettingsForm from './InputLayoutSettingsForm';
import CompositePublisher from './CompositePublisher';
import CompositeVideo from './CompositeVideo';

import './Composite.css';

const FullscreenButton = ({ videoRef }) => {
  const handleFullscreen = () => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else if (videoElement.webkitEnterFullscreen) {
      videoElement.webkitEnterFullscreen(); // Safari on iOS
    }
  };

  return <button className="btn btn-secondary mt-2" onClick={handleFullscreen}>Fullscreen</button>;
};

const Composite = () => {
  const videoRef = useRef(null);
  return (
    <div className="container-fluid mt-3" id="composite-content">
      <div id="composite-content-inner">
        <div className="row justify-content-center">
          <div className="col-md-8 col-sm-12">
            <div id="composite-video-container" className="mb-4" style={{ position: 'relative' }}>
              <CompositeVideo videoRef={videoRef} />
              <Compositor />
              <CompositeLiveIndicator />
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <CompositePublishSettingsForm />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-sm-12">
            <InputLayoutSettingsForm />
          </div>
        </div>
        <div className="row justify-content-center">
            <FullscreenButton videoRef={videoRef} />
        </div>
      </div>
      <CompositePublisher />
    </div>
  );
}

export default Composite;